
export const REWARD_TYPES = {
  STEPUP: "STEPUP",
  MILESTONE: "MILESTONE",
} as const;

export const FIELD_NAMES = {
  IS_MILESTONE_REWARD: "isMilestoneReward",
  PRICE_CUT: "priceCut",
  SHOW_ON_HOME_WIDGET: "showOnHomeWidget",
  CUTOFF_DATE: "cutoffDate",
  DURATION: "duration",
} as const;

export const NO_REWARD_INFO = {
  id: "NO_REWARD",
  name: "No Reward",
} as const;
